module.exports = __webpack_public_path__ + "img/Girl_030013.22bd0e7c.png";